import axios from 'axios'


var myaxios = {};
myaxios.install = function(Vue, options) {
  var axios_obj = axios.create({
    // 驻马店官网.baseURL: 'http://ht.zmdscjrlhh.org.cn/f/zmd',
    baseURL: 'http://ht.zmdscjrlhh.org.cn/f/zmd',
    // 77环境 'http://127.0.0.1:8087/f/zmd',
    // baseURL: 'http://127.0.0.1:8087/f/zmd',
    // headers:{Authorization:window.localStorage.getItem('token')}
  })

  Vue.prototype.$myHttp = axios_obj;
}
//图片所在的后台服务地址
window.localServerHost = 'http://192.168.0.77:8087';

export default myaxios;

// get使用及传参 this是vue对象
/**
 * this.$myHttp.get("getOrderMonitorInfo", {params: {year: year}})
  .then(function(data0) {
    if (data0.status == "200") {

    } else {
      alert("数据请求错误")
    }

  })
  .catch(function(error) {
    alert(error)
  })

 *
 * */

  // post使用及传参
 /**
  * this.$myHttp.post("getOrderMonitorInfo", {year: year})
    .then(function(data0) {
      if (data0.status == "200") {

      } else {
        alert("数据请求错误")
      }

    })
    .catch(function(error) {
      alert(error)
    })
 *
 * */



// WEBPACK FOOTER //
// ./src/assets/js/myaxios.js